export function joinCustomerContext(...values: readonly (string | null | undefined)[]): string {
  return values
    .map((value) => value?.trim() ?? '')
    .filter((value) => value.length > 0)
    .join('\n');
}
